module.exports = __webpack_public_path__ + "static/media/growth_copy.5256f4a0.svg";